module.exports = __webpack_public_path__ + "static/img/baby-gibbon.9b6ab9e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/amenities/tables/baby-gibbon.jpg
// module id = 622
// module chunks = 0